import DeleteModal from "../components/DeleteModal";
import { deleteCollection } from "../clients/collection";

function DeleteCollectionModal(props) {
  return (
    <DeleteModal
      request={deleteCollection}
      id={props.id}
      onClose={props.onClose}
      onDelete={props.onDelete}
      toastMessage="The collection was deleted"
      title="Delete collection?"
      confirmText={props.name}
      message={
        <p className="m-0">
          Do you want to delete&nbsp;
          <span className="text-muted">{props.name}</span>
          &nbsp;permanently?
        </p>
      }
    />
  );
}

export default DeleteCollectionModal;
